import IconButton from '@material-ui/core/IconButton';
import Help from '@material-ui/icons/Help';
import PropTypes from 'prop-types';
import React from 'react';

/* eslint-disable max-lines-per-function */
// eslint-disable-next-line require-jsdoc
export default function HelpIcon(props) {
  return (
    <IconButton
      edge='start'
      color='default'
      style={props.style}
      onClick={() => window.open('/Help.pdf')}
      aria-label='close'
    >
      <Help />
    </IconButton>
  );
}
HelpIcon.propTypes = {
  style: PropTypes.object
};
